import { createRoute } from "@tanstack/react-router";

import { shellRoute } from "@platform/shell.route";
import { TenantPage } from "./tenant.page";

// Session-only (inherited from the shell). Role-gated actions are enforced
// per-action by the server. ?create forces the create-tenant view even
// for users already in a tenant (the sidebar "New tenant" entry).
export const tenantRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/tenant",
	validateSearch: (search: Record<string, unknown>): { create?: boolean } => ({
		create: search.create === true || search.create === "true" || undefined,
	}),
	component: TenantPage,
});
